import { DateTime } from "luxon";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@components/Dialog";
import { Image } from "@components/Image";
import { Link } from "@components/Link";
import { Typography } from "@components/Typography";

import type { TPost } from "@api/modelCamPosts";

import { ASSETS_BASE_URL, ICON_PATHS } from "@configs/icons";

export type RejectedPostDialogProps = {
	post: TPost;
	onClose: () => void;
};

export const RejectedPostDialog = ({ onClose, post }: RejectedPostDialogProps) => {
	const formatDate = (date: string) => {
		const dateTime = DateTime.fromISO(date);
		const offset = dateTime.offset / 60;
		const sign = offset >= 0 ? "+" : "-";
		const absOffset = Math.abs(offset);
		return `${dateTime.toFormat("dd.MM.yyyy HH:mm")} (GMT${sign}${absOffset})`;
	};

	return (
		<Dialog open onOpenChange={(open) => !open && onClose()}>
			<DialogContent className="w-110 max-w-[calc(100vw-32px)] pb-6">
				<DialogHeader>
					<DialogTitle>Post rejected</DialogTitle>
				</DialogHeader>

				<div className="mx-auto mb-5 block min-h-51.25 w-full rounded-lg bg-info pb-5">
					<Image
						width={40}
						height={57}
						className="mx-auto mt-3.75 block h-14.25 w-10 pt-5"
						src={ICON_PATHS.WARNING}
						alt="warning"
					/>
					<div className="mx-auto my-2.5 flex min-h-22.5 w-[90%] items-center justify-center pt-2.5 text-center">
						<Typography type="p" padding="none" size="lg" align="center">
							{post?.reject_reason}
						</Typography>
					</div>
					<Typography type="p" padding="none" color="subTitle" align="center" size="sm">
						{formatDate(post?.created_at)}
					</Typography>
				</div>
				<div className="mt-5">
					<Typography type="p" padding="none" color="subTitle" align="center" size="sm">
						Our content monitors have determined that your behavior at Dreamcam has been in violation of our{" "}
						<Link
							href={`${ASSETS_BASE_URL}/TERMS%20OF%20SERVICE.pdf`}
							target="_blank"
							rel="noreferrer"
							color="textPrimary"
							underline="none"
							size="sm"
							className="hover:text-white hover:opacity-60"
						>
							TERMS OF USE
						</Link>
					</Typography>
				</div>

				<div className="mt-5">
					<Typography type="p" color="subTitle" padding="none" align="center" size="sm">
						If you think we made a mistake please contact us{" "}
						<Link
							href="mailto:support@dreamcam.com"
							color="textPrimary"
							underline="none"
							size="sm"
							className="hover:text-white hover:opacity-60"
						>
							support@dreamcam.com
						</Link>
					</Typography>
				</div>
			</DialogContent>
		</Dialog>
	);
};
